import { FC } from 'react';
import { Outlet } from 'react-router-dom';

interface WizardLayoutProps {
  currentStep?: number;
  totalSteps?: number;
}

/**
 * Wizard Layout Component
 * Clean, minimal layout for the onboarding wizard
 */
const WizardLayout: FC<WizardLayoutProps> = () => {
  return (
    <div className="min-h-screen bg-white">
      <Outlet />
    </div>
  );
};

export default WizardLayout;

